/** Guard допускает только числа с точкой\запятой */
export var guardFloat = function guardFloat(value) {
  var t = 0;
  return value.replace(/[^0-9,.]/g, '').replace(/[,.]/, '.').replace(/[,.]/g, function (m) {
    return ++t > 1 ? '' : m;
  });
};